function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Collector from "../../../../../../services/collector";
import Icon from "../../../../../common/icon";
import { useWorkFlow } from "../../../../../contexts/workflow";
import TranslateObj from "../../../../../common/translation-object";
import { _translate } from "../../../../../../services/core";
var ResponseBuilder = function ResponseBuilder(_ref) {
  var response = _ref.response,
    onChange = _ref.onChange,
    parentKeyToDisplay = _ref.parentKeyToDisplay;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var currentOrder = collector.currentOrder,
    responses = collector.responses,
    currentQuestion = collector.currentQuestion;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    isPrioritized = _useState2[0],
    setIsPrioritized = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    checked = _useState4[0],
    setChecked = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    label = _useState6[0],
    setLabel = _useState6[1];
  var validator = function validator() {
    if (typeof response === 'boolean') {
      return;
    }
    if (response.checked === undefined) {
      response.checked = true;
    }

    // Vérification si dans la liste des réponses cette valeur est déjà prises.
    var currentResponse2 = Collector.getCurrentOrderResponses(currentOrder, responses);
    var list = currentResponse2 === null || currentResponse2 === void 0 ? void 0 : currentResponse2.responses;
    var isChecked = false;
    if (list) {
      Object.keys(list).forEach(function (key) {
        var value = list[key];
        if (value === response.alias || value === response.value) {
          isChecked = true;
        }
      });
    }
    setChecked(isChecked);
    setLabel( /*#__PURE__*/React.createElement(TranslateObj, {
      from: response.name
    }));
    setIsPrioritized(currentQuestion.prioritizedExpectedResponses && currentQuestion.prioritizedExpectedResponses.includes(response.alias));
  };
  useEffect(function () {
    validator();
  }, [collector]);
  if (typeof response === 'boolean') {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(e) {
      onChange(response, checked, e);
      setChecked(!checked);
    },
    className: "categorized-line response pl-3 w-100 text-left ".concat(isPrioritized ? 'prioritized' : '', " ").concat(checked ? 'checked text-danger' : '')
  }, !parentKeyToDisplay && /*#__PURE__*/React.createElement(Icon, {
    className: "icon-categorized ml-2",
    name: "caret-right"
  }), parentKeyToDisplay ? _translate(parentKeyToDisplay) : label);
};
export default ResponseBuilder;